import React from 'react';
import { MenuItemProps, Popover } from 'freemium-ui';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useGetCurrentUser } from '../../../routes/screens/settings/hooks';
import { alphabetColors } from '../../constants';

const options: Array<MenuItemProps> = [
  {
    id: 'profile',
    name: 'profile_settings',
    path: '/profile',
  },
  {
    id: 'logout',
    name: 'sign_out',
    path: '/freshid/logout',
  },
];
type ProfileProps = {
  src?: string;
};

const Profile = (props: ProfileProps) => {
  const { t } = useTranslation();
  const { src } = props;
  const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState<any>(null);
  const { data: loggedInUser } = useGetCurrentUser({});
  return (
    <ProfileContainer
      alphabet={get(loggedInUser?.email, [0], '').toUpperCase()}
    >
      <div
        className="profile-wrapper"
        tabIndex={0}
        role="button"
        aria-describedby="profile-dropdown"
        onKeyDown={(event) => setAnchorEl(event.currentTarget)}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        {src ? (
          <img alt="profile" src={src} />
        ) : (
          <div className="letter">
            {get(loggedInUser?.email, [0], '').toUpperCase()}
          </div>
        )}
      </div>
      <Popover
        id="profile-dropdown"
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuContainer>
          <div className="header">
            <div className="name">
              {`${loggedInUser?.first_name || ''} ${
                loggedInUser?.middle_name || ''
              } ${loggedInUser?.last_name || ''}`.trim()}
            </div>
            <div className="email">{loggedInUser?.email}</div>
          </div>
          <div className="menu-content">
            {options.map((opt: MenuItemProps) => (
              <div
                className="menu-item"
                key={opt.id}
                onClick={() => history.push(opt.path)}
              >
                {t(opt.name)}
              </div>
            ))}
          </div>
        </MenuContainer>
      </Popover>
    </ProfileContainer>
  );
};

const ProfileContainer = styled.div<{ alphabet?: string }>`
  display: grid;
  place-content: center;
  margin-left: 14px;
  div.letter {
    background: ${({ alphabet }) =>
      alphabetColors[(alphabet || '').toLowerCase()] || '#ffe0b2'};
    border-radius: 4px;
    height: inherit;
    width: inherit;
    display: grid;
    place-content: center;
    font-weight: bold;
    font-size: 18px;
    user-select: none;
    color: #ffffff;
  }
  div.profile-wrapper {
    height: 32px;
    width: 32px;
    cursor: pointer;
    img {
      height: inherit;
      width: inherit;
      border-radius: 50%;
    }
  }
`;

export default Profile;

const MenuContainer = styled.div`
  background: #ffffff;
  min-height: 120px;
  min-width: 250px;
  position: absolute;
  right: 0;
  top: 5px;
  z-index: 15;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  box-shadow: rgb(0 0 0 / 6%) 0px 2px 3px, rgb(25 50 71 / 16%) 0px 4px 20px;
  .menu-content {
    padding: 8px;
    .menu-item {
      width: 100%;
      padding: 10px;
      cursor: pointer;
      cursor: pointer;
      outline: none;
      min-width: 100px;
      color: rgb(18, 52, 77);
      border-radius: 4px;
      white-space: nowrap;
      padding: 8px;
      font-size: 14px;
      &:hover {
        background-color: rgb(229, 236, 255);
      }
    }
  }
  .header {
    cursor: default;
    padding: 15px;
    background: var(--bg-info);
    .name {
      font-weight: 600;
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      color: var(--base-color);
      margin-bottom: 5px;
    }

    .email {
      font-size: 12px;
      white-space: nowrap;
      overflow: hidden;
      color: var(--secondary-color);
    }
  }
`;
